import { render, staticRenderFns } from "./ClassificationHeader.vue?vue&type=template&id=dbac73e0&scoped=true"
import script from "./ClassificationHeader.vue?vue&type=script&lang=js"
export * from "./ClassificationHeader.vue?vue&type=script&lang=js"
import style0 from "./ClassificationHeader.vue?vue&type=style&index=0&id=dbac73e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbac73e0",
  null
  
)

export default component.exports